export const trading = {
    等待确认: 'Waiting for confirmation',
    gas矿工费: 'Gas miner fee',
    审核扫描: 'Audit Scan',
    警报: 'Alert',
    无警报: 'No Alert',
    显示更多: 'Show More',
    Infos: "These audit results are automated and conducted by external entities outside of Biking. They are not recommendations and should be considered alongside other factors. Biking does not verify or take responsibility for the quality of data obtained through these external auditors. Always conduct your own research and consult multiple sources of information.",
    请输数量: 'Enter quantity',
    兑换: 'Exchange',
    价格: 'Price',
    选择代币: 'Select Token',
    搜索名称或粘贴地址: 'Search by name or paste address',
    DEXT分数: 'DEXT Score',
    更多检测: 'More checks',
    检查审核: 'Check audit',
    令牌描述: 'Token description',
    更新: 'Update',
    合同验证: 'Contract verification',
    买入税: 'Buy tax',
    代理合同: 'Proxy contract',
    可造币: 'Mintable',
    可修改税收: 'Modifiable tax',
    转让可暂停: 'Transfer pauseable',
    黑名单: 'Blacklist',
    找回所有权: 'Recover ownership',
    可修改余额: 'Modifiable balance',
    隐藏的所有者: 'Hidden owner',
    自毁: 'Self-destruct',
    外部呼叫风险: 'External call risk',
    可以购买: 'Purchaseable',
    最大卖出比率: 'Maximum sell rate',
    白名单: 'Whitelist',
    反鲸鱼可修改: 'Anti-whale modifiable',
    交易冷却时间: 'Transaction cooldown time',
    可修改的个人税收: 'Modifiable personal tax',
    真的假的代币: 'Genuine/Fake token',
    空投骗局: 'Airdrop scam',
    可以信任: 'Trustable',
    业主地址: "Owner's address",
    所有者余额: "Owner's balance",
    业主百分比: "Owner's percentage",
    创建者地址: "Creator's address",
    创造者余额: "Creator's balance",
    创造者百分比: "Creator's percentage",
    配对持有者: 'Pair holder',
    其他风险: 'Other risks',
    注意: 'Attention',
    交易: 'Transactions',
    dex委托: 'Swap commission',
    dex历史委托: 'Swap historical commission',
    kpsj: 'Opening Time',
    jlks: 'Time to Start',
    t: 'Days',
    s: 'Hours',
    f: 'Minutes',
    m: 'Seconds',

    zgj: 'Highest price：',
    zdj: 'Lowest price：',
    gflj: 'official link',
    gw: 'official website',
    qkllq: 'block explorer',
    scfxsj: 'first issue date',
    fxzl: 'total issuance',
    ltzl: 'total circulation',
    jy: 'Trade',
    sj: 'Market price',
    tbxx: 'Chart',
    bzgk: 'Overview',
    jcb: 'Basic version',
    ddb: 'Order form',
    zxcj: 'Latest transaction',
    
    reload: "refresh",
    socketError: "Network error, please",
    noData: "No data",
    entrustorder: "Order Book",
    prices: "Price",
    quantity: "Amount",
    grandtotal: "Cumulative",
    transamount: "Total",
    time: "Time",
    available: "Available",
    limitorder: "Limit",
    plancommission: "Trigger order",
    currentcommission: "Entrust",
    historycommission: "Order History",
    completecommission: "Completed",
    funds: 'Funds',
    hidetrading: "Hide others",
    morecurrentcommission: "More Orders",
    morehistorycommission: "More histories",
    moredocommission: "More dealed",
    realtimetrans: "Real-time",
    myassets: "My assets",
    detail: "Details",
    buyin: "BUY",
    sellout: "SELL",
    login: "Login",
    transfer: "Transfer",
    recharge: "Deposit",
    withdrawal: "Buy Crypto",
    quickpurchase: "OTC quick purchase",
    default: "Default",
    ordertime: "Order Time",
    "windingtime": "Time of putting on the chain",
    tradingpair: "Pair",
    direction: "Side",
    types: "Type",
    commissionprice: "Order Price",
    commissionnumber: "Order Amount",
    dealprice: "Deal Average Price",
    dealnumber: "Deal Amount",
    triggerprice: "Trigger Price",
    cancelall: "Cancel all",
    averageprice: "Ave price",
    totalsum: "Sum",
    fixedprice: "Limit price",
    marketprice: "Market price",
    codeExpired: "QR Code expired",
    clickRefresh: "Click to refresh",
    QRsuccessfully: "Successfully",
    loginInApp: "Please confirm your login in the APP",
    backtoQR: "Back to QR Code login",
    loginSuccess: "Login successfully, welcome to BiKing.",
    loadingText: "Loading...",
    searchPlaceholder: "search",
    all: "All",
    currency: "Pair",
    price: "Latest Price",
    market: "Increase",
    increase: "change",
    highestPrice: "Highest",
    minimumPrice: "Lowest",
    turnover: " Vol",
    jydlb: "Trading Pair",
    bzjs: "Introduction",
    currencyTransaction: "Spot",
    leveragedTransaction: "Leverage",
    warning:
      "Risk Warning: Bitcoin Cash fork has great uncertainty. Trading or investing in fork futures tokens is highly risky. Any chain lacking the support of miners may be unable to survive, which results in a value zero-out of tokens held. BiKing does not make any promise for the value of any forked futures tokens!",
    zb: "Indicatrix",
    UpAnddown: "Change",
    amplitude: "amplitude",
    0: "TL",
    1: "1M",
    5: "5M",
    15: "15M",
    30: "30M",
    60: "1H",
    240: "4H",
    3600: "1Day",
    10800: "1W",
    dates: "Cycle：",
    password: "Trade password",
    errorPassword: "Please enter correct password",
    worningPassword: "Please enter the trade password",
    cancel: "Cancel",
    sure: "Confirm",
    canBuy: "Total Asset Valuation",
    canCell: "Total Asset Valuation",
    withdraw: "Withdraw",
    otc: "OTC，Fast Deposit and Withdrawal Fiat",
    enterPrice: "Please enter the price",
    sellingPrice: "Price",
    purchasePrice: "Price",
    salesTurnover: "sell amount",
    buyingTurnover: "Buy amount",
    buyingVolume: "Amount",
    salesVolume: "Amount",
    volume: "Total",
    Turnover: "Turnover",
    serviceCharge: "Fee",
    vip: "Join VIP  to enjoy fee discount",
    or: "or",
    register: "Sign up",
    totalPrice: "Trading amount cannot be greater than",
    amountTip: "Please enter the correct amount",
    amountTipError: "Quantity cannot be greater than",
    limitTrading: "Limit Order",
    priceReminder: "price alert",
    SMSReminder: "SMS Alerts",
    loginAccount: "Login account",
    phone: "phone",
    phoneNum: "Please enter your phone number",
    phoneTips: "Please enter correct phone number",
    email: "email",
    emailNum: "Please enter email address",
    emailTips: "Please enter correct email address",
    aears: "Please select area code",
    passwordError: "Please enter correct password",
    passwordTips: "Please enter password",
    forgetPassword: "Forgot password",
    noAccount: "Not on BiKing yet",
    goRegister: "Register Now",
    appsys: "Scan in APP to login",
    xzapp: "Download the latest version of APP",
    mmdl: "Enter password",
    smdl: "Scan code",
    google: "Google authenticator",
    nybd: "You have linked a ",
    zqyzm: "Please enter correct verification code",
    fsyzm: "Send Code",
    flv: "Fee Rate",
    jz: "Net worth",
    jzdesc1:
      "Long net worth = net worth at the last adjustment point * [1 + 3 * (the latest executed price of the spot-the price at the last adjustment point of the spot) / price at the last adjustment point of the spot * 100%];",
    jzdesc2:
      "Short net worth = net worth at the last adjustment point * [1 - 3 * (the latest executed price of the spot-the price at the last adjustment point of the spot) / price at the last adjustment point of the spot * 100%];",
    sbd: "3XL",
    sbs: "3XS",
    flvjs:
      "ETF fund rate is the daily management fee charged in proportion for leverage by the platform to pay the funding rate generated by the fund portfolio. The management fee will be manifested on the dynamics of net worth. It is only charged at 00:00 (Singapore time). No fee will be charged if you do not hold Leveraged ETF product at the time point.",
    mzsm: "Disclaimer",
    ido: "I have read and agree",
    exemption1: "Dear user, hello!",
    exemption2:
      'Thank you for logging in and using the leverage ETF products and related services (hereinafter referred to as "ETF products") provided by BiKing.ai. Please read the ETF product description and the following risk warnings carefully. If you choose to continue using ETF products after it, it is deemed that you have fully acknowledged and understood the risks of ETF products, and have the capacity to bear the losses that may be caused by using ETF products. Also, you agree with the entire contents of this disclaimer.Please click to read the ETF product description: ',
    exemption3: "《Leverage ETF Product FAQ》",
    exemption4: "Risk warning：",
    exemption5:
      "1. The price you buy / sell should not deviate significantly from the unit's net worth, otherwise you will suffer corresponding losses.",
    exemption6:
      "2. If the direction is wrong, there will be a risk that the price will approach zero in extreme conditions.",
    exemption7:
      "BiKing hereby solemnly reminds you that any losses or liabilities caused by the above risks will be borne by you and BiKing will not bear any responsibility for this. This disclaimer, together with other agreements, statements, rules, etc., constitute all the agreements reached on the services and products of the BiKing between you and BiKing.",
    bzjs1:
      '1、"3L" means the price of underlying trading pair increase 1%, so that the product\'s net worth increase 3%',
    bzjs2:
      '2、"3S" means the price of underlying trading pair decrease 1%, so that the product\'s net worth increase 3%',
    bzjs3:
      "3、The net worth is normally adjusted at 0 o'clock every day, and is adjusted intraday under extreme market.",
    bzjs4:
      "4、Each times leverage will charge the corresponding management fee on a daily basis",
    bzjs5:
      "5、Please pay attention to check the net worth before trading. Under extreme market conditions, the price will approach zero, and will deviate far from the net worth. Investors should pay attention to controlling risks",
    gdjk: "Please refer to News for more details",
    firstTrading: "Please set trade password before your first trading",
    status: "Status",
    status1: "To be matched",
    status2: "Uncompleted",
    status3: "Canceled",
    status4: "Partially completed",
    status5: "Completed",
    status6: "Invalid",
    allCancel:
      "Batch cancel all orders",
    canceld: "Cancelled",
    cancelsuccess:
      "All orders have been cancelled successfully, [*] orders have been cancelled",
    VIP1: "Your VIP level",
    VIP2: "Lower transaction fee cost, but better transaction experience",
    VIP3: "Taker：",
    VIP4: "Maker：",
    buyAmount: "Buy quantity cannot be greater than",
    sellAmount: "Sell quantity cannot be greater than",
    buyAmountMin: "Your available balance is insufficient",
    sellAmountMin: "Your available balance is insufficient",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/en.js